import { Injectable } from "@angular/core";
import { NotificationService } from "./notification.service";
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { UserService } from "./user.service";
import { SearchService } from "./search.service";
//import { saveAs } from 'file-saver';

@Injectable({
    providedIn: "root",
})
export class ExportPassService {


    constructor(
        private notificationService: NotificationService,
        private http: HttpClient,
        private searchService: SearchService,
        private userService: UserService
    ) { }

    public exportSearch(key: string, description: string, screenName: string) {
        const apiURL = environment.getAPI("exportSearch");
        const httpOptions: { headers; observe } = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            }),
            observe: "response",
        };
        const body: {
            UserID: number;
            TableName: string;
            Key: string;
            Description: string;
            ScreenName: string;
        } = {
            UserID: this.userService.userID,
            TableName: this.getTableName(),
            Key: key,
            Description: description,
            ScreenName: screenName,
        };
        const res = this.http.post<any>(apiURL, body, httpOptions);
        return res;
    }

    public checkExportSearch(key: string, description: string, screenName: string) {
        const apiURL = environment.getAPI("checkExportSearch");
        const httpOptions: { headers; observe } = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            }),
            observe: "response",
        };
        const body: {
            UserID: number;
            TableName: string;
            Key: string;
            Description: string;
            ScreenName: string;
        } = {
            UserID: this.userService.userID,
            TableName: this.getTableName(),
            Key: key,
            Description: description,
            ScreenName: screenName,
        };
        const res = this.http.post<any>(apiURL, body, httpOptions);
        return res;
    }

     // get DB Table Name
  public getTableName(): string {
    let tableName = "";
    switch (this.searchService.getPageName().toLowerCase()) {
      case "Person Of Interest".toLowerCase():
        tableName = "PersonOfInterest";
        break;
      case "Transportation People".toLowerCase():
        tableName = "TransportationPeople";
        break;
      case "POIRequester".toLowerCase():
        tableName = "POIRequester";
        break;
    }

    return tableName;
  }
    /*
    downloadCSVDirect(exportQueueID: number): void {

        const link = document.createElement('a'); //creates <a> HTML element in DOM
        link.href = url;                          //<a> behave like normal download link when clicked
        link.download = 'export.csv';
       // link.setAttribute('download', `${exportQueueID}.csv`); //it tells browser to downlod it instead of navigating to it
        document.body.appendChild(link);          //temporarily adds <a> ele to DOM body of the page
        link.click();                             //clicking the link
        document.body.removeChild(link);          //removes the <a> from DOM (cleaning up)
    }
        */
        

    /*
 downloadFile(exportQueueId: string): void {
    fetch(fileUrl)
      .then(response => response.blob())
      .then(blob => {
        saveAs(blob, `Export_${exportQueueId}.csv`);
      });
  }
      */

  /*
  async downloadCSVDirect(exportQueueID: number): Promise<void> {

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Network response was not ok');

    const blob = await response.blob();

    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = `${exportQueueID}.csv`;

    // Show "Save As" dialog
    a.click();

    // Cleanup
    setTimeout(() => {
      window.URL.revokeObjectURL(blobUrl);
    }, 100);
  } catch (err) {
    console.error('Error downloading file:', err);
  }
}
  */


public getDownloadUrl(fileKey: string) {
  const apiURL = environment.getAPI("getDownloadUrl");
  const httpOptions: { headers; observe } = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
    observe: "response",
  };
  const body = {
    fileKey: fileKey,
  };
  return this.http.post<any>(apiURL, body, httpOptions);
}

async downloadCSVDirect(exportQueueID: number, description: string): Promise<void> {
  try {
    const fileKey = `${exportQueueID}.csv`;
    const urlResponse = await this.getDownloadUrl(fileKey).toPromise() as HttpResponse<any>;
    const url = urlResponse?.body?.downloadUrl;
    if (!url) throw new Error('Download URL not returned');

    const response = await fetch(url);
    if (!response.ok) throw new Error('Network response was not ok');

    const blob = await response.blob();
    let modifiedDescription = description?.split(' ')?.join('_');
    console.log("desc",modifiedDescription);
        
    // Use FileSaver.js if you want better support (optional)
    const blobUrl = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = `${modifiedDescription}.csv`;

    // Add it to the DOM and simulate click
    document.body.appendChild(a);
    a.click();

    // Remove and revoke
    document.body.removeChild(a);
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error('Error downloading file:', err);
  }
}

    deleteExportedFile(ExportQueueID: number) {
        const apiURL = environment.getAPI("deleteExport");
        const httpOptions: { headers; observe } = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            }),
            observe: "response",
        };
        const body = {
            ExportQueueID: ExportQueueID,
        }
        const res = this.http.post<any>(apiURL, body, httpOptions);
        return res;
    }

}